var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.739 0H18.2609C8.19122 0 0 8.19122 0 18.2609V75.6523C0 85.7218 8.19122 93.913 18.2609 93.913H74.5723L99.8923 119.238C100.393 119.734 101.061 120 101.739 120C102.073 120 102.412 119.932 102.736 119.802C103.711 119.4 104.348 118.445 104.348 117.391V93.7303C113.186 92.4574 120 84.8347 120 75.6521V18.2609C120 8.19122 111.809 0 101.739 0ZM114.782 75.6521C114.782 82.8468 108.929 88.6954 101.739 88.6954C100.299 88.6954 99.1303 89.8642 99.1303 91.3042V111.094L77.4991 89.4574C77.0086 88.9721 76.3459 88.6954 75.6521 88.6954H18.2609C11.0715 88.6954 5.21755 82.8466 5.21755 75.6521V18.2609C5.21755 11.0661 11.0715 5.21755 18.2609 5.21755H101.739C108.929 5.21755 114.782 11.0663 114.782 18.2609V75.6521Z",
    fill: "#424A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 62.6085C55.685 62.6085 52.1738 66.1197 52.1738 70.4347C52.1738 74.7494 55.685 78.2606 59.9997 78.2606C64.3147 78.2606 67.8259 74.7494 67.8259 70.4347C67.8259 66.1197 64.3147 62.6085 59.9997 62.6085ZM59.9997 73.0435C58.5597 73.0435 57.3912 71.8694 57.3912 70.4347C57.3912 68.9997 58.5597 67.8259 59.9997 67.8259C61.4397 67.8259 62.6085 68.9997 62.6085 70.4347C62.6085 71.8694 61.4397 73.0435 59.9997 73.0435Z",
    fill: "#0086FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3374 18.1459C66.8609 16.56 64.7739 15.6521 62.6086 15.6521H57.3912C55.2262 15.6521 53.1444 16.56 51.6677 18.1459C50.1912 19.7268 49.4345 21.8712 49.5859 24.073L51.793 49.7789C52.0954 54.0468 55.6853 57.391 59.9998 57.391C64.278 57.391 67.8677 54.0466 68.1651 49.8207L70.4139 24.0363C70.5703 21.8765 69.8139 19.7323 68.3374 18.1459ZM65.2174 23.6242L62.9635 49.4139C62.8539 50.9635 61.5497 52.1739 59.9583 52.1739C58.4035 52.1739 57.1044 50.9635 56.9895 49.3721L54.7877 23.6662C54.7356 22.9303 54.9807 22.2312 55.4815 21.6991C55.9824 21.1668 56.6607 20.8695 57.391 20.8695H62.6086C63.3391 20.8695 64.0174 21.1668 64.5183 21.6991C65.0191 22.2312 65.2644 22.9303 65.2174 23.6242Z",
    fill: "#0086FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExclamation);
export default __webpack_public_path__ + "static/media/icn-exclamation.8ad680062073c9459c4f0acdd7c92662.svg";
export { ForwardRef as ReactComponent };